import classNames from 'classnames';
import React, {FC} from 'react';
import {Arrows} from '~/shared/legacy_presentational-components/Elements/Elements';
import styles from './Form.module.scss';

interface ButtonInterface {
    type?: 'button' | 'submit' | 'reset' | undefined;
    title: string;
    bottomButton?: boolean;
    arrowsButton?: boolean;
    newStyleButton?: boolean;
    disabled?: boolean;
    fullWidth?: boolean;
    inlineBtn?: boolean;
    noMarginTop?: boolean;
    formId?: string;
    className?: string;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void | null | Promise<void>;
}

/**
 * @deprecated
 * @see {@link '@raison/ui-kit'.RsnButton}
 */
const Button: FC<ButtonInterface> = ({
    type,
    title,
    bottomButton,
    arrowsButton,
    newStyleButton,
    disabled,
    fullWidth,
    inlineBtn,
    noMarginTop,
    formId,
    className,
    onClick,
}) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => !disabled && onClick && onClick(e);

    const buttonClassName = () => {
        if (bottomButton) {
            return classNames(styles.bottomButton, {
                [styles.bottomButton_disabled]: disabled,
                [styles.button_fullWidth]: fullWidth,
                [styles.button_inlineBtn]: inlineBtn,
                [`${className}`]: className,
            });
        }

        if (arrowsButton) {
            return classNames(styles.arrowsButton, {
                [styles.arrowsButton_disabled]: disabled,
                [styles.button_fullWidth]: fullWidth,
                [`${className}`]: className,
            });
        }

        if (newStyleButton) {
            return classNames(styles.simpleButton, {
                [styles.simpleButton_disabled]: disabled,
                [styles.button_fullWidth]: fullWidth,
                [`${className}`]: className,
            });
        }

        return classNames(styles.button, {
            [styles.button_disabled]: disabled,
            [styles.button_inlineBtn]: inlineBtn,
            [styles.button_fullWidth]: fullWidth,
            [styles.noMarginTopButton]: noMarginTop,
            [`${className}`]: className,
        });
    };

    return (
        <button
            className={buttonClassName()}
            type={type}
            disabled={disabled}
            onClick={e => handleClick(e)}
            form={formId}
        >
            {title} {arrowsButton ? <Arrows /> : ''}
        </button>
    );
};

export default Button;
